import Layout from '@/views/layout/Layout'

const ClientOutsourceAddEditForOutsource = () => import('@/views/resource/clientOutsourceAddEditForOutsource')
const ClientOutsourceDetailForOutsource = () => import('@/views/resource/clientOutsourceDetailForOutsource')

const PersonOutsourceAddEditForOutsource = () => import('@/views/resource/personOutsourceAddEditForOutsource')
const PersonnelOutsourceDetailForOutsource = () => import('@/views/resource/personnelOutsourceDetailForOutsource')

const EmployeeAddEditForOutsource = () => import('@/views/resource/employeeAddEditForOutsource')
const EmployeeListForOutsource = () => import('@/views/resource/employeeListForOutsource')

export const personnelMaps = [
  {
    path: '/outsource',
    component: Layout,
    menuName: '外包商管理',
    meta: { icon: 'icon-textile-products' },
    children: [
      {
        path: 'detail',
        component: PersonnelOutsourceDetailForOutsource,
        name: 'PersonnelOutsourceDetailForOutsource',
        menuName: '详细信息',
        meta: { title: '详细信息', tagName: '详细信息' }
      },
      {
        path: 'employee_list',
        component: EmployeeListForOutsource,
        name: 'EmployeeListForOutsource',
        menuName: '人员管理',
        meta: { title: '人员管理', tagName: '人员管理' }
      },
      {
        path: 'edit',
        component: PersonOutsourceAddEditForOutsource,
        name: 'PersonOutsourceAddEditForOutsource',
        menuName: '信息编辑',
        hidden: true,
        meta: { title: '信息编辑', tagName: '信息编辑' }
      },
      {
        path: 'employee_add_edit',
        component: EmployeeAddEditForOutsource,
        name: 'EmployeeAddEditForOutsource',
        hidden: true,
        menuName: '人员备案',
        meta: { title: '人员备案', tagName: '人员备案' }
      }
    ]
  }
]

export const enterpriseMaps = [
  {
    path: '/outsource',
    component: Layout,
    menuName: '外包商管理',
    meta: { icon: 'icon-textile-products' },
    children: [
      {
        path: 'detail',
        component: ClientOutsourceDetailForOutsource,
        name: 'ClientOutsourceDetailForOutsource',
        menuName: '详细信息',
        meta: { title: '详细信息', tagName: '详细信息' }
      },
      {
        path: 'employee_list',
        component: EmployeeListForOutsource,
        name: 'EmployeeListForOutsource',
        menuName: '人员管理',
        meta: { title: '人员管理', tagName: '人员管理' }
      },
      {
        path: 'edit',
        component: ClientOutsourceAddEditForOutsource,
        name: 'ClientOutsourceAddEditForOutsource',
        menuName: '信息编辑',
        hidden: true,
        meta: { title: '信息编辑', tagName: '信息编辑' }
      },
      {
        path: 'employee_add_edit',
        component: EmployeeAddEditForOutsource,
        name: 'EmployeeAddEditForOutsource',
        hidden: true,
        menuName: '人员备案',
        meta: { title: '人员备案', tagName: '人员备案' }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/outsourceAsyncMap.js